import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button, { ArrowIcon } from '../components/Button';
import SectionLabel from '../components/SectionLabel';
import UrgencyBanner, { SESSION_NAME, TOTAL_PLACES, PLACES_PRISES, PLACES_RESTANTES } from '../components/UrgencyBanner';
import { candidatures, notifications } from '../lib/supabase';
import './Home.css';

// Icons SVG components
const Icons = {
  Check: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  X: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  ),
  ArrowRight: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
  ),
  DollarSign: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"></line>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
    </svg>
  ),
  Target: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <circle cx="12" cy="12" r="6"></circle>
      <circle cx="12" cy="12" r="2"></circle>
    </svg>
  ),
  Globe: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="2" y1="12" x2="22" y2="12"></line>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    </svg>
  ),
  Zap: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
    </svg>
  ),
  Cpu: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
      <rect x="9" y="9" width="6" height="6"></rect>
      <line x1="9" y1="1" x2="9" y2="4"></line>
      <line x1="15" y1="1" x2="15" y2="4"></line>
      <line x1="9" y1="20" x2="9" y2="23"></line>
      <line x1="15" y1="20" x2="15" y2="23"></line>
      <line x1="20" y1="9" x2="23" y2="9"></line>
      <line x1="20" y1="14" x2="23" y2="14"></line>
      <line x1="1" y1="9" x2="4" y2="9"></line>
      <line x1="1" y1="14" x2="4" y2="14"></line>
    </svg>
  ),
  TrendingUp: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
  Shield: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  Lock: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
    </svg>
  ),
  Clock: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  ),
  Users: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  BookOpen: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
    </svg>
  ),
  Award: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="7"></circle>
      <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
    </svg>
  ),
  Briefcase: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    </svg>
  ),
  Headphones: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
      <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  ),
  AlertTriangle: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  ),
  Lightbulb: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="9" y1="18" x2="15" y2="18"></line>
      <line x1="10" y1="22" x2="14" y2="22"></line>
      <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"></path>
    </svg>
  ),
  Sparkles: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l1.912 5.813a2 2 0 001.275 1.275L21 12l-5.813 1.912a2 2 0 00-1.275 1.275L12 21l-1.912-5.813a2 2 0 00-1.275-1.275L3 12l5.813-1.912a2 2 0 001.275-1.275L12 3z"></path>
    </svg>
  ),
  Gift: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12"></polyline>
      <rect x="2" y="7" width="20" height="5"></rect>
      <line x1="12" y1="22" x2="12" y2="7"></line>
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
    </svg>
  ),
  HelpCircle: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  ),
  Heart: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
  ),
  Rocket: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
    </svg>
  ),
  Frown: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M16 16s-1.5-2-4-2-4 2-4 2"></path>
      <line x1="9" y1="9" x2="9.01" y2="9"></line>
      <line x1="15" y1="9" x2="15.01" y2="9"></line>
    </svg>
  ),
  Search: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  XCircle: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </svg>
  ),
  BarChart: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="20" x2="12" y2="10"></line>
      <line x1="18" y1="20" x2="18" y2="4"></line>
      <line x1="6" y1="20" x2="6" y2="16"></line>
    </svg>
  ),
  Layout: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="3" y1="9" x2="21" y2="9"></line>
      <line x1="9" y1="21" x2="9" y2="9"></line>
    </svg>
  ),
  Code: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 18 22 12 16 6"></polyline>
      <polyline points="8 6 2 12 8 18"></polyline>
    </svg>
  ),
  Infinity: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.739-8-4.585 0-4.585 8 0 8 5.606 0 7.644-8 12.74-8z"></path>
    </svg>
  ),
};

// Composant Video Testimonial
const VideoTestimonial = ({ src, name, onPlayChange }) => {
  const videoRef = React.useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
        onPlayChange(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
        onPlayChange(true);
      }
    }
  };

  const handleEnded = () => {
    setIsPlaying(false);
    onPlayChange(false);
  };

  return (
    <div className="video-testimonial" onClick={togglePlay}>
      <video
        ref={videoRef}
        src={src}
        playsInline
        onEnded={handleEnded}
      />
      {!isPlaying && (
        <div className="video-play-overlay">
          <div className="video-play-btn">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
          </div>
        </div>
      )}
      <div className="video-name-tag">{name}</div>
      <div className="video-badge-f12ia">F12IA</div>
    </div>
  );
};

// ============================================
// HERO DEMO - Animated AI coding simulation
// ============================================
const codeLines = [
  { text: '> claude "Crée un site vitrine pour un restaurant"', type: 'command' },
  { text: '', type: 'blank' },
  { text: '  Analyse du brief...', type: 'ai-think' },
  { text: '  Génération du code...', type: 'ai-think' },
  { text: '', type: 'blank' },
  { text: '  ✓ Header + Navigation', type: 'success' },
  { text: '  ✓ Section Hero avec image', type: 'success' },
  { text: '  ✓ Menu du restaurant', type: 'success' },
  { text: '  ✓ Formulaire de réservation', type: 'success' },
  { text: '  ✓ Footer + Contact', type: 'success' },
  { text: '  ✓ Design responsive mobile', type: 'success' },
  { text: '', type: 'blank' },
  { text: '  ✨ Site déployé → restaurant-lyon.fr', type: 'deploy' },
  { text: '  💰 Facturé au client : 1 200€', type: 'revenue' },
];

const previewSteps = [
  { id: 'nav', label: 'Navigation', delay: 3000 },
  { id: 'hero-block', label: 'Hero', delay: 4500 },
  { id: 'menu-block', label: 'Menu', delay: 6000 },
  { id: 'form-block', label: 'Réservation', delay: 7500 },
  { id: 'footer-block', label: 'Footer', delay: 9000 },
];

const HeroDemo = () => {
  const [visibleLines, setVisibleLines] = useState(0);
  const [activePreview, setActivePreview] = useState([]);
  const [isStarted, setIsStarted] = useState(false);
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    const startTimer = setTimeout(() => setIsStarted(true), 800);
    return () => clearTimeout(startTimer);
  }, []);

  useEffect(() => {
    if (!isStarted) return;
    setVisibleLines(0);
    setActivePreview([]);

    const lineTimers = codeLines.map((_, i) => {
      const delay = i * 600 + (codeLines[i].type === 'command' ? 0 : 200);
      return setTimeout(() => setVisibleLines(i + 1), delay);
    });

    const previewTimers = previewSteps.map((step) =>
      setTimeout(() => setActivePreview(prev => [...prev, step.id]), step.delay)
    );

    const resetTimer = setTimeout(() => {
      setCycle(c => c + 1);
    }, 14000);

    return () => {
      lineTimers.forEach(clearTimeout);
      previewTimers.forEach(clearTimeout);
      clearTimeout(resetTimer);
    };
  }, [isStarted, cycle]);

  return (
    <div className="hero-demo">
      {/* Floating particles */}
      <div className="demo-particles">
        {[...Array(6)].map((_, i) => (
          <div key={i} className={`demo-particle dp-${i + 1}`} />
        ))}
      </div>

      <div className="demo-window">
        {/* Terminal side */}
        <div className="demo-terminal">
          <div className="terminal-header">
            <div className="terminal-dots">
              <span className="dot dot-red" />
              <span className="dot dot-yellow" />
              <span className="dot dot-green" />
            </div>
            <span className="terminal-title">Terminal — Claude Code</span>
          </div>
          <div className="terminal-body">
            {codeLines.slice(0, visibleLines).map((line, i) => (
              <div key={`${cycle}-${i}`} className={`code-line cl-${line.type} code-line-enter`}>
                {line.type === 'command' && <span className="line-prompt">$</span>}
                {line.text}
                {i === visibleLines - 1 && line.type !== 'blank' && (
                  <span className="cursor-blink">│</span>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Preview side */}
        <div className="demo-preview">
          <div className="preview-header">
            <div className="preview-dots">
              <span className="dot dot-red" />
              <span className="dot dot-yellow" />
              <span className="dot dot-green" />
            </div>
            <div className="preview-url">
              <span className="url-lock">🔒</span>
              restaurant-lyon.fr
            </div>
          </div>
          <div className="preview-body">
            <div className={`preview-block pb-nav ${activePreview.includes('nav') ? 'pb-visible' : ''}`}>
              <div className="pb-nav-logo">🍽️ Le Bistrot</div>
              <div className="pb-nav-links">
                <span></span><span></span><span></span>
              </div>
            </div>
            <div className={`preview-block pb-hero ${activePreview.includes('hero-block') ? 'pb-visible' : ''}`}>
              <div className="pb-hero-text">
                <div className="pb-h1"></div>
                <div className="pb-p"></div>
                <div className="pb-btn">Réserver</div>
              </div>
              <div className="pb-hero-img">📸</div>
            </div>
            <div className={`preview-block pb-menu ${activePreview.includes('menu-block') ? 'pb-visible' : ''}`}>
              <div className="pb-menu-title">Notre Carte</div>
              <div className="pb-menu-grid">
                <div className="pb-menu-item"><span>🥗</span></div>
                <div className="pb-menu-item"><span>🥩</span></div>
                <div className="pb-menu-item"><span>🍷</span></div>
              </div>
            </div>
            <div className={`preview-block pb-form ${activePreview.includes('form-block') ? 'pb-visible' : ''}`}>
              <div className="pb-form-title">Réservation</div>
              <div className="pb-form-fields">
                <div className="pb-input"></div>
                <div className="pb-input"></div>
                <div className="pb-submit">Réserver</div>
              </div>
            </div>
            <div className={`preview-block pb-footer ${activePreview.includes('footer-block') ? 'pb-visible' : ''}`}>
              <div className="pb-footer-text">© 2026 Le Bistrot Lyon</div>
            </div>
          </div>
        </div>
      </div>

      <div className="demo-caption">
        <span className="demo-live-dot"></span>
        L'IA construit. Tu factures.
      </div>
    </div>
  );
};

const Home = () => {
  const navigate = useNavigate();
  const [faqOpen, setFaqOpen] = useState(null);
  const [inlineFormData, setInlineFormData] = useState({ email: '', acceptTerms: false });
  const [isSubmittingInline, setIsSubmittingInline] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const toggleFaq = (index) => {
    setFaqOpen(faqOpen === index ? null : index);
  };

  const handleInlineFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setInlineFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const canProceedInlineStep1 = inlineFormData.email && inlineFormData.acceptTerms &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inlineFormData.email);

  const handleInlineStep1 = async (e) => {
    e.preventDefault();
    if (!canProceedInlineStep1) return;

    setIsSubmittingInline(true);

    try {
      // Sauvegarder l'email dans Supabase
      const { data, error } = await candidatures.captureEmail(inlineFormData.email);
      if (error) {
        console.error('Erreur capture email:', error);
      } else {
        console.log('✅ Email capturé depuis Home:', data);
        // Notifier les admins en arrière-plan (ne bloque pas la navigation)
        notifications.notifyEmailCaptured(inlineFormData.email);
      }
    } catch (err) {
      console.error('Erreur:', err);
    }

    // Rediriger vers /inscription avec l'email pré-rempli
    navigate('/inscription', {
      state: {
        email: inlineFormData.email,
        acceptTerms: true,
        fromHome: true
      }
    });
  };

  // Scroll reveal animations
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll('.reveal');
    revealElements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="landing">
      {/* Skip link for accessibility */}
      <a href="#main-content" className="skip-link">
        Aller au contenu principal
      </a>

      {/* BANDEAU URGENCE STICKY */}
      <UrgencyBanner />

      {/* Main content wrapper for accessibility */}
      <main id="main-content">

      {/* HERO */}
      <section className="hero">
        {/* Animated orbs */}
        <div className="hero-orbs">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="orb orb-3"></div>
          <div className="orb orb-4"></div>
        </div>

        <div className="hero-content">

          <SectionLabel icon={<Icons.Zap />}>Formation + Clients Inclus</SectionLabel>

          <h1>Formation Web Business Rentable en 30 Jours ou 100% remboursé.</h1>

          <p className="hero-subtitle-large">
            Sans écrire une ligne de code, <span className="text-gradient">clients inclus.</span>
          </p>

          <p className="hero-tagline">
            L'IA code. On t'envoie les clients. <span className="text-gradient">Tu encaisses.</span>
          </p>

          {/* Animated Hero Demo */}
          <HeroDemo />

          <div className="hero-features">
            <div className="hero-feature">
              <Icons.Check />
              <span>Pas besoin de savoir coder</span>
            </div>
            <div className="hero-feature">
              <Icons.Check />
              <span>On te donne les clients</span>
            </div>
            <div className="hero-feature">
              <Icons.Check />
              <span>Jusqu'à 2 500€/mois</span>
            </div>
          </div>

          <div className="hero-cta">
            <Button to="/inscription" size="lg">
              Je postule maintenant
              <ArrowIcon />
            </Button>
            <span className="cta-free">Places limitées - Sans engagement</span>
          </div>

          <p className="hero-guarantee">
            <Icons.Shield />
            Garantie : Première mission en 30 jours ou Remboursé
          </p>

        </div>

        <div className="hero-gradient"></div>
      </section>

      {/* COMMENT CA MARCHE */}
      <section className="section section-process">
        <div className="container">
          <div className="section-header reveal">
            <SectionLabel icon={<Icons.Rocket />}>Le parcours</SectionLabel>
            <h2>Comment ça marche</h2>
            <p className="section-desc">4 étapes pour passer de zéro à rentable.</p>
          </div>

          <div className="process-timeline reveal">
            <div className="process-step">
              <div className="process-number">1</div>
              <div className="process-icon">
                <Icons.BookOpen />
              </div>
              <h3>Tu postules</h3>
              <p>Candidature gratuite en 2 min. On vérifie ta motivation.</p>
            </div>

            <div className="process-connector"></div>

            <div className="process-step">
              <div className="process-number">2</div>
              <div className="process-icon">
                <Icons.Cpu />
              </div>
              <h3>Tu te formes</h3>
              <p>30 jours de formation. L'IA code, tu apprends à la diriger.</p>
            </div>

            <div className="process-connector"></div>

            <div className="process-step">
              <div className="process-number">3</div>
              <div className="process-icon">
                <Icons.Award />
              </div>
              <h3>Tu te certifies</h3>
              <p>Projet final validé par l'équipe. Certification officielle F12IA.</p>
            </div>

            <div className="process-connector"></div>

            <div className="process-step">
              <div className="process-number">4</div>
              <div className="process-icon">
                <Icons.DollarSign />
              </div>
              <h3>Tu encaisses</h3>
              <p>On t'envoie des clients. Tu fais les sites. Tu factures.</p>
            </div>
          </div>

          <div className="process-cta reveal">
            <Button to="/inscription" size="lg">
              Commencer le parcours
              <ArrowIcon />
            </Button>
          </div>
        </div>
      </section>

      {/* PROBLEM */}
      <section className="section section-dark">
        <div className="container">

          <div className="section-header reveal">
            <SectionLabel icon={<Icons.AlertTriangle />} variant="warning">Le constat</SectionLabel>
            <h2>Le vrai problème des formations en ligne</h2>
            <p className="section-desc">95% des formés ne gagnent jamais un euro. Voici pourquoi.</p>
          </div>

          <div className="problem-grid reveal reveal-stagger">
            <div className="problem-card">
              <div className="problem-icon">
                <Icons.Frown />
              </div>
              <p>Tu paies une formation. Tu regardes des vidéos. <strong>Et après ?</strong></p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">
                <Icons.Search />
              </div>
              <p>Tu te retrouves seul à <strong>chercher des clients</strong> pendant des mois.</p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">
                <Icons.XCircle />
              </div>
              <p>Tu as investi du temps et de l'argent. <strong>Résultat : 0€.</strong></p>
            </div>
            <div className="problem-card">
              <div className="problem-icon">
                <Icons.BarChart />
              </div>
              <p>Statistique : <strong>95% des formés ne gagnent jamais 1€</strong> avec leur formation.</p>
            </div>
          </div>

          <div className="problem-solution reveal">
            <p className="text-muted">Le problème, c'est pas toi. C'est le modèle.</p>
            <p className="text-gradient text-lg">On a décidé de faire l'inverse.</p>
          </div>

        </div>
      </section>

      {/* SOLUTION */}
      <section className="section">
        <div className="container">

          <div className="section-header reveal">
            <SectionLabel icon={<Icons.Lightbulb />}>La méthode</SectionLabel>
            <h2>Formation + Missions = Le seul modèle qui marche</h2>
            <p className="section-desc">On ne te vend pas une formation. On te propose un métier.</p>
          </div>

          <div className="steps reveal reveal-stagger">

            <div className="step">
              <div className="step-content">
                <div className="step-header">
                  <h3>Tu te formes</h3>
                  <span className="step-badge">30 jours</span>
                </div>
                <ul className="step-list">
                  <li>Modules pas-à-pas, même si tu pars de zéro</li>
                  <li>L'IA écrit le code, tu apprends à la diriger</li>
                  <li>Tu crées ton premier site en 7 jours</li>
                </ul>
              </div>
            </div>

            <div className="step">
              <div className="step-content">
                <div className="step-header">
                  <h3>Tu te certifies</h3>
                  <span className="step-badge">7 jours</span>
                </div>
                <ul className="step-list">
                  <li>Tu réalises un site test complet</li>
                  <li>On review et on te donne du feedback</li>
                  <li>Tu corriges jusqu'à ce que ce soit pro</li>
                </ul>
              </div>
            </div>

            <div className="step">
              <div className="step-content">
                <div className="step-header">
                  <h3>Tu reçois des missions</h3>
                  <span className="step-badge success">Dès la certification</span>
                </div>
                <ul className="step-list">
                  <li>On a les clients, on te les envoie</li>
                  <li>Tu fais les sites, tu encaisses</li>
                  <li>Jusqu'à 740€ par site réalisé</li>
                </ul>
              </div>
            </div>

          </div>

          <div className="solution-footer">
            <p>Pas de prospection. Pas de galère. <strong>Juste du travail.</strong></p>
          </div>

        </div>
      </section>

      {/* BENEFITS */}
      <section className="section section-dark">
        <div className="container">

          <div className="section-header reveal">
            <SectionLabel icon={<Icons.TrendingUp />} variant="success">Les résultats</SectionLabel>
            <h2>Ce que tu gagnes concrètement</h2>
            <p className="section-desc">Des chiffres réels, pas des promesses en l'air.</p>
          </div>

          <div className="benefits-grid reveal reveal-stagger">

            <div className="benefit-card benefit-main">
              <div className="benefit-amount">2 000 - 3 000€<span>/mois</span></div>
              <p>Avec 3-4 sites par mois, c'est ce que gagnent nos créateurs certifiés actifs.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon"><Icons.Target /></div>
              <h3>Clients livrés sur un plateau</h3>
              <p>On a plus de demandes que de créateurs. Tu ne cherches pas, tu produis.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon"><Icons.Globe /></div>
              <h3>Travaille d'où tu veux</h3>
              <p>Un ordi, une connexion. Chez toi, en voyage, au café.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon"><Icons.Zap /></div>
              <h3>Résultats en 30 jours</h3>
              <p>Pas dans 2 ans. Dans 2 mois, tu peux avoir tes premières missions.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon"><Icons.Cpu /></div>
              <h3>L'IA fait le technique</h3>
              <p>Tu n'apprends pas à coder. Tu apprends à faire coder l'IA.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon"><Icons.TrendingUp /></div>
              <h3>Un métier d'avenir</h3>
              <p>La demande explose. Cette compétence ne se dévalue pas.</p>
            </div>

          </div>

          <div className="roi-box reveal">
            <div className="roi-item">
              <span className="roi-label">Investissement</span>
              <span className="roi-value">1 980€</span>
            </div>
            <div className="roi-divider"></div>
            <div className="roi-item">
              <span className="roi-label">Revenu année 1</span>
              <span className="roi-value">~30 000€</span>
            </div>
            <div className="roi-divider"></div>
            <div className="roi-item">
              <span className="roi-label">ROI</span>
              <span className="roi-value roi-highlight">x15</span>
            </div>
          </div>

          <div className="section-cta-inline reveal">
            <Button to="/inscription" size="lg">
              Je veux ces résultats
              <ArrowIcon />
            </Button>
            <span className="cta-inline-note">Candidature gratuite - Places limitées</span>
          </div>

        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="section section-testimonials">
        <div className="container">
          <div className="section-header reveal">
            <SectionLabel icon={<Icons.Users />} variant="success">Témoignages</SectionLabel>
            <h2>Ils l'ont fait. À ton tour.</h2>
            <p className="section-desc">Des résultats réels, des vrais certifiés, des vrais revenus.</p>
          </div>
        </div>

        {/* Row 1 - Scrolling Left */}
        <div className={`testimonials-marquee ${isVideoPlaying ? 'paused' : ''}`}>
          <div className="testimonials-track">
            {/* Set 1 */}
            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">2 340 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Lucas P.</span>
                  <span className="screenshot-period">Oct. 2024</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-video-real">
              <VideoTestimonial
                src="/testimonial-1.mp4"
                name="Thomas D."
                onPlayChange={setIsVideoPlaying}
              />
            </div>

            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"En 5 semaines j'étais certifié. Le mois suivant, 2 340€."</p>
                <div className="quote-author">
                  <div className="quote-avatar">A</div>
                  <span>Antoine M.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">1 850 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Julie R.</span>
                  <span className="screenshot-period">Nov. 2024</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-video-real">
              <VideoTestimonial
                src="/testimonial-2.mp4"
                name="Sarah M."
                onPlayChange={setIsVideoPlaying}
              />
            </div>

            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"Je facture 3x plus qu'avant. La formation m'a ouvert les yeux."</p>
                <div className="quote-author">
                  <div className="quote-avatar">E</div>
                  <span>Emma S.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">3 120 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Maxime L.</span>
                  <span className="screenshot-period">Nov. 2024</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"3 000€+/mois en parallèle de mes études."</p>
                <div className="quote-author">
                  <div className="quote-avatar">S</div>
                  <span>Sofiane K.</span>
                </div>
              </div>
            </div>

            {/* Duplicate for loop */}
            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">2 340 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Lucas P.</span>
                  <span className="screenshot-period">Oct. 2024</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"En 5 semaines j'étais certifié. Le mois suivant, 2 340€."</p>
                <div className="quote-author">
                  <div className="quote-avatar">A</div>
                  <span>Antoine M.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">1 850 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Julie R.</span>
                  <span className="screenshot-period">Nov. 2024</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"Je facture 3x plus qu'avant. La formation m'a ouvert les yeux."</p>
                <div className="quote-author">
                  <div className="quote-avatar">E</div>
                  <span>Emma S.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">3 120 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Maxime L.</span>
                  <span className="screenshot-period">Nov. 2024</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"3 000€+/mois en parallèle de mes études."</p>
                <div className="quote-author">
                  <div className="quote-avatar">S</div>
                  <span>Sofiane K.</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Row 2 - Scrolling Right (slower) */}
        <div className={`testimonials-marquee marquee-reverse ${isVideoPlaying ? 'paused' : ''}`}>
          <div className="testimonials-track track-reverse">
            {/* Set 1 */}
            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"Le support répond en 24h max. On n'est jamais seul."</p>
                <div className="quote-author">
                  <div className="quote-avatar">M</div>
                  <span>Marie C.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">2 890 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Sophie R.</span>
                  <span className="screenshot-period">Déc. 2024</span>
                </div>
              </div>
            </div>


            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"J'ai quitté mon CDI. Meilleure décision de ma vie."</p>
                <div className="quote-author">
                  <div className="quote-avatar">N</div>
                  <span>Nicolas T.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">1 480 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Lucas P.</span>
                  <span className="screenshot-period">Nov. 2024</span>
                </div>
              </div>
            </div>


            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"Premier site livré en 6h. Le client était choqué."</p>
                <div className="quote-author">
                  <div className="quote-avatar">R</div>
                  <span>Romain D.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">2 220 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Julie R.</span>
                  <span className="screenshot-period">Déc. 2024</span>
                </div>
              </div>
            </div>


            {/* Duplicate for loop */}
            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"Le support répond en 24h max. On n'est jamais seul."</p>
                <div className="quote-author">
                  <div className="quote-avatar">M</div>
                  <span>Marie C.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">2 890 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Sophie R.</span>
                  <span className="screenshot-period">Déc. 2024</span>
                </div>
              </div>
            </div>


            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"J'ai quitté mon CDI. Meilleure décision de ma vie."</p>
                <div className="quote-author">
                  <div className="quote-avatar">N</div>
                  <span>Nicolas T.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">1 480 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Lucas P.</span>
                  <span className="screenshot-period">Nov. 2024</span>
                </div>
              </div>
            </div>


            <div className="testimonial-item testimonial-quote">
              <div className="quote-card">
                <p>"Premier site livré en 6h. Le client était choqué."</p>
                <div className="quote-author">
                  <div className="quote-avatar">R</div>
                  <span>Romain D.</span>
                </div>
              </div>
            </div>

            <div className="testimonial-item testimonial-screenshot">
              <div className="screenshot-card">
                <div className="screenshot-header">
                  <Icons.DollarSign />
                  <span>Stripe</span>
                </div>
                <div className="screenshot-amount">2 220 €</div>
                <div className="screenshot-info">
                  <span className="screenshot-name">Lucas P.</span>
                  <span className="screenshot-period">Déc. 2024</span>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="container">
          <div className="section-cta-inline reveal">
            <Button to="/inscription" size="lg">
              Rejoindre ces certifiés
              <ArrowIcon />
            </Button>
            <span className="cta-inline-note">+50 certifiés actifs - Candidature gratuite</span>
          </div>
        </div>
      </section>

      {/* LIFESTYLE / FREEDOM */}
      <section className="section section-lifestyle">
        <div className="container container-sm">

          <div className="section-header reveal">
            <SectionLabel icon={<Icons.Sparkles />}>La vraie promesse</SectionLabel>
            <h2>Ce n'est pas qu'une formation.<br/>C'est un style de vie.</h2>
            <p className="section-desc">La liberté que tu mérites, accessible en 30 jours.</p>
          </div>

          <div className="lifestyle-grid reveal reveal-stagger">
            <div className="lifestyle-card">
              <div className="lifestyle-icon">
                <Icons.Globe />
              </div>
              <h3>Liberté géographique</h3>
              <p>Travaille depuis chez toi, un café à Bali, ou un Airbnb au Portugal. Tout ce qu'il te faut : <strong>un ordi et du wifi.</strong></p>
            </div>

            <div className="lifestyle-card">
              <div className="lifestyle-icon">
                <Icons.DollarSign />
              </div>
              <h3>Liberté financière</h3>
              <p>Fini de compter les jours jusqu'à la paie. Tu gagnes en fonction de ton travail, <strong>sans plafond.</strong></p>
            </div>

            <div className="lifestyle-card">
              <div className="lifestyle-icon">
                <Icons.Clock />
              </div>
              <h3>Liberté de temps</h3>
              <p>Pas de patron, pas d'horaires imposés. Tu organises tes journées <strong>comme tu veux.</strong></p>
            </div>
          </div>

          <div className="lifestyle-quote reveal">
            <p>"Imagine te réveiller demain sans alarme, ouvrir ton ordi depuis n'importe où dans le monde, et savoir que chaque heure de travail te rapproche de tes objectifs — pas de ceux d'un patron."</p>
          </div>

        </div>
      </section>

      {/* FOR WHO */}
      <section className="section section-for-who">
        <div className="container">

          <div className="section-header reveal">
            <SectionLabel icon={<Icons.Users />}>Pour qui ?</SectionLabel>
            <h2>Cette formation est faite pour toi si...</h2>
            <p className="section-desc">On ne prend pas tout le monde. Voici le profil idéal.</p>
          </div>

          <div className="for-who-container reveal">
            {/* Yes side - Main focus */}
            <div className="for-who-yes">
              <div className="for-who-yes-header">
                <div className="for-who-icon-yes">
                  <Icons.Check />
                </div>
                <span>Tu es au bon endroit</span>
              </div>
              <div className="for-who-yes-grid">
                <div className="for-who-item">
                  <div className="for-who-item-icon"><Icons.Target /></div>
                  <p>Tu veux un <strong>revenu supplémentaire</strong> ou changer de vie</p>
                </div>
                <div className="for-who-item">
                  <div className="for-who-item-icon"><Icons.Zap /></div>
                  <p>Tu es prêt à <strong>bosser</strong> pour obtenir des résultats</p>
                </div>
                <div className="for-who-item">
                  <div className="for-who-item-icon"><Icons.Globe /></div>
                  <p>Tu rêves de <strong>liberté</strong> et d'indépendance</p>
                </div>
                <div className="for-who-item">
                  <div className="for-who-item-icon"><Icons.TrendingUp /></div>
                  <p>Tu veux du <strong>concret</strong>, pas de la théorie</p>
                </div>
              </div>
            </div>

            {/* No side - Redesigned */}
            <div className="for-who-no">
              <div className="for-who-no-header">
                <div className="for-who-icon-no">
                  <Icons.X />
                </div>
                <span>Pas fait pour toi si...</span>
              </div>
              <div className="for-who-no-grid">
                <div className="for-who-no-item">
                  <Icons.X />
                  <span>Tu cherches de l'argent facile sans effort</span>
                </div>
                <div className="for-who-no-item">
                  <Icons.X />
                  <span>Tu n'as pas 5-10h par semaine à consacrer</span>
                </div>
                <div className="for-who-no-item">
                  <Icons.X />
                  <span>Tu veux des résultats sans apprentissage</span>
                </div>
                <div className="for-who-no-item">
                  <Icons.X />
                  <span>Tu n'es pas prêt à suivre une méthode</span>
                </div>
              </div>
            </div>
          </div>

          <div className="section-cta-inline reveal">
            <Button to="/inscription" size="lg">
              Je suis prêt, je candidate
              <ArrowIcon />
            </Button>
            <span className="cta-inline-note">Candidature sans engagement</span>
          </div>

        </div>
      </section>

      {/* OFFER */}
      <section className="section section-dark">
        <div className="container container-sm">

          <div className="section-header reveal">
            <SectionLabel icon={<Icons.Gift />}>L'offre</SectionLabel>
            <h2>Tout ce que tu reçois</h2>
            <p className="section-desc">Un investissement unique pour des revenus récurrents.</p>
          </div>

          <div className="offer-card reveal">

            <div className="offer-item">
              <div className="offer-icon"><Icons.BookOpen /></div>
              <div className="offer-info">
                <h4>Formation complète</h4>
                <p>De zéro à autonome</p>
              </div>
              <span className="offer-value">2 000€</span>
            </div>

            <div className="offer-item">
              <div className="offer-icon"><Icons.Infinity /></div>
              <div className="offer-info">
                <h4>Accès à vie + mises à jour</h4>
                <p>Tu paies une fois, tu gardes pour toujours</p>
              </div>
              <span className="offer-value">300€</span>
            </div>

            <div className="offer-item">
              <div className="offer-icon"><Icons.Users /></div>
              <div className="offer-info">
                <h4>Communauté privée</h4>
                <p>Entraide, questions, motivation</p>
              </div>
            </div>

            <div className="offer-item">
              <div className="offer-icon"><Icons.Award /></div>
              <div className="offer-info">
                <h4>Certification officielle</h4>
                <p>Prouve ton niveau</p>
              </div>
            </div>

            <div className="offer-item">
              <div className="offer-icon"><Icons.Briefcase /></div>
              <div className="offer-info">
                <h4>Module Création d'entreprise</h4>
                <p>Auto-entrepreneur France + LLC USA</p>
              </div>
              <span className="offer-value">500€</span>
            </div>

            <div className="offer-item offer-highlight">
              <div className="offer-icon"><Icons.Briefcase /></div>
              <div className="offer-info">
                <h4>Accès au Pool de Missions</h4>
                <p>Des clients réels, de l'argent à gagner</p>
              </div>
              <span className="offer-value">2 000€</span>
            </div>

            <div className="offer-item">
              <div className="offer-icon"><Icons.Headphones /></div>
              <div className="offer-info">
                <h4>Support prioritaire dédié</h4>
                <p>Réponse sous 24h</p>
              </div>
            </div>

            <div className="offer-total">
              <div className="offer-total-row">
                <span>Valeur totale</span>
                <span className="striked">4 800€</span>
              </div>
              <div className="offer-total-row offer-price-row">
                <span>Ton prix aujourd'hui</span>
                <span className="offer-price">1 980€</span>
              </div>
              <p className="offer-payment">ou 3 × 660€ sans frais</p>
            </div>

          </div>

          <div className="offer-cta reveal">
            <Button to="/inscription" size="xl" fullWidth>
              Rejoindre F12IA
              <ArrowIcon />
            </Button>
            <span className="cta-free">Places limitées - Sans engagement</span>
            <p className="offer-note">Places limitées pour garantir des missions à tous</p>
          </div>

        </div>
      </section>

      {/* GUARANTEE */}
      <section className="section section-guarantee">
        <div className="container">

          <div className="guarantee-wrapper reveal reveal-scale">
            <div className="guarantee-content">
              <div className="guarantee-badge">
                <Icons.Shield />
                <span>Garantie officielle</span>
              </div>

              <h2>Première mission en 30 jours.<br/><span className="text-gradient">Ou 100% remboursé.</span></h2>

              <p className="guarantee-desc">
                Tu te formes. Tu te certifies. On t'envoie ta première mission.
                <strong> Si tu ne reçois pas de mission dans les 30 jours suivant ta certification, on te rembourse intégralement.</strong>
              </p>
            </div>

            <div className="guarantee-visual">
              <div className="guarantee-shield">
                <Icons.Shield />
              </div>
              <div className="guarantee-tag">
                <span className="guarantee-tag-number">30j</span>
                <span className="guarantee-tag-text">Mission garantie</span>
              </div>
            </div>
          </div>

          <p className="guarantee-footer-text">
            <Icons.Lock /> Le risque est pour nous, pas pour toi.
          </p>

        </div>
      </section>

      {/* FAQ */}
      <section className="section section-dark">
        <div className="container container-sm">

          <div className="section-header reveal">
            <SectionLabel icon={<Icons.HelpCircle />}>FAQ</SectionLabel>
            <h2>Tes questions</h2>
            <p className="section-desc">Les réponses aux interrogations les plus fréquentes.</p>
          </div>

          <div className="faq-list reveal">

            {[
              {
                q: "Je n'ai aucune compétence technique. C'est vraiment pour moi ?",
                a: "Oui, c'est exactement pour toi. Tu n'apprends pas à coder. Tu apprends à diriger une IA qui code pour toi. Si tu sais écrire un email, tu peux faire ça."
              },
              {
                q: "Combien je peux vraiment gagner ?",
                a: "Ça dépend de ton implication. Avec 3-4 sites par mois, les certifiés actifs gagnent entre 2 000€ et 3 000€. En side-hustle (1-2 sites), compte 700€ à 1 500€/mois."
              },
              {
                q: "C'est garanti que j'aurai des missions ?",
                a: "Si tu es certifié et disponible, oui. On a plus de clients que de créateurs. C'est pour ça qu'on forme des gens."
              },
              {
                q: "Et si je n'ai pas de mission ?",
                a: "Notre garantie est claire : si tu ne reçois pas de mission dans les 30 jours suivant ta certification, on te rembourse intégralement. On a plus de clients que de créateurs, donc ce n'est jamais arrivé."
              },
              {
                q: "Combien de temps ça prend par semaine ?",
                a: "Pour la formation : 5-10h par semaine pendant 4-5 semaines. Ensuite, chaque site prend environ 4-8h selon la complexité."
              },
              {
                q: "Je peux faire ça en side-hustle ?",
                a: "Absolument. 1-2 sites par mois, c'est 700-1 500€ de revenus supplémentaires sans quitter ton job."
              },
              {
                q: "Quel statut je dois avoir ?",
                a: "Auto-entrepreneur (micro-entreprise). On t'explique comment le créer en 15 minutes dans la formation."
              }
            ].map((item, index) => (
              <div
                key={index}
                className={`faq-item ${faqOpen === index ? 'open' : ''}`}
                onClick={() => toggleFaq(index)}
              >
                <div className="faq-question">
                  <span className="faq-question-text">{item.q}</span>
                  <div className={`faq-toggle ${faqOpen === index ? 'open' : ''}`}>
                    <span className="faq-toggle-line"></span>
                    <span className="faq-toggle-line"></span>
                  </div>
                </div>
                <div className="faq-answer">
                  <p>{item.a}</p>
                </div>
              </div>
            ))}

          </div>

        </div>
      </section>

      {/* POURQUOI ON LIMITE */}
      <section className="section section-limit">
        <div className="container container-sm">
          <div className="limit-box reveal">
            <div className="limit-icon">
              <Icons.Users />
            </div>
            <h3>Pourquoi seulement 10 places par session ?</h3>
            <p>
              On reçoit des demandes de création de sites internet de nos clients en continu.
              Pour garantir que chaque nouveau certifié reçoive des missions, on limite volontairement à <strong>10 nouvelles personnes</strong> par session.
            </p>
            <p className="limit-conclusion">
              10 places max = des missions garanties pour chacun.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="section section-cta">
        <div className="cta-glow"></div>
        <div className="container container-sm">

          <div className="section-header reveal">
            <SectionLabel icon={<Icons.Rocket />} variant="success">C'est le moment</SectionLabel>
            <h2>Dans 30 jours, tu auras soit des excuses, soit des résultats.</h2>
          </div>

          <div className="cta-card reveal reveal-scale">

            {/* Compteur visuel de places */}
            <div className="places-counter">
              <div className="places-label">Session {SESSION_NAME}</div>
              <div className="places-dots">
                {[...Array(TOTAL_PLACES)].map((_, i) => (
                  <div
                    key={i}
                    className={`place-dot ${i < PLACES_PRISES ? 'taken' : 'available'}`}
                    title={i < PLACES_PRISES ? 'Place prise' : 'Place disponible'}
                  />
                ))}
              </div>
              <div className="places-info">
                <span className="places-taken">{PLACES_PRISES} places prises</span>
                <span className="places-separator">•</span>
                <span className="places-available">{PLACES_RESTANTES} restantes</span>
              </div>
            </div>

            <ul className="cta-card-benefits">
              <li><Icons.Check /> Candidature gratuite et sans engagement</li>
              <li><Icons.Check /> Réponse sous 48h</li>
              <li><Icons.Check /> Entretien personnalisé</li>
            </ul>

            {/* Inline Form - Capture email puis redirection */}
            <div className="inline-form-wrapper">
              <form className="inline-form" onSubmit={handleInlineStep1}>
                <div className="inline-form-field">
                  <input
                    type="email"
                    name="email"
                    value={inlineFormData.email}
                    onChange={handleInlineFormChange}
                    placeholder="Ton adresse email"
                    required
                  />
                  <button type="submit" disabled={isSubmittingInline || !canProceedInlineStep1}>
                    {isSubmittingInline ? (
                      <span className="inline-spinner"></span>
                    ) : (
                      <Icons.ArrowRight />
                    )}
                  </button>
                </div>
                <label className="inline-form-consent">
                  <input
                    type="checkbox"
                    name="acceptTerms"
                    checked={inlineFormData.acceptTerms}
                    onChange={handleInlineFormChange}
                  />
                  <span className="inline-checkmark"></span>
                  <span>J'accepte d'être recontacté(e) pour ma candidature</span>
                </label>
              </form>
            </div>

            <div className="cta-card-guarantee">
              <Icons.Shield />
              <span>Garantie : Première mission en 30 jours ou 100% remboursé</span>
            </div>
          </div>

          <div className="cta-trust">
            <div className="cta-trust-item">
              <Icons.Clock />
              <span>Places limitées</span>
            </div>
            <div className="cta-trust-item">
              <Icons.Zap />
              <span>Réponse rapide</span>
            </div>
            <div className="cta-trust-item">
              <Icons.Users />
              <span>+50 certifiés</span>
            </div>
          </div>

        </div>
      </section>

      </main>
    </div>
  );
};

export default Home;
